<template>
  <div class="flex items-center justify-center w-full">
    <div
      v-if="show && error.length"
      class="flex relative w-[90%] rounded-lg px-6 py-6 mt-12 bg-[#ffffff] border-[1px] shadow-md border-gray-100 dark:bg-[#1b1c20] dark:border-[#232932]"
    >
      <a
        @click.stop.prevent="close"
        class="inline-block absolute top-[-8px] left-[-8px] w-[62px] cursor-pointer"
      >
        <span
          class="inline-flex justify-center items-center w-[26px] h-[26px] rounded-full bg-[#dedede] dark:bg-[#31313b] text-[#8a8993] dark:text-white"
          >X</span
        >
      </a>
      <p class="flex flex-row items-center space-x-2 text-fire">
        <span class="text-[#3f3c51] dark:text-gold"
          ><ExclamationCircleIcon class="w-8 h-8 text-fire"
        /></span>
        <span>{{ error }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { ExclamationCircleIcon } from "@heroicons/vue/solid";

export default {
  name: "ErrorComponent",
  components: {
    ExclamationCircleIcon,
  },
  props: {
    error: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const close = () => {
      emit("close");
    };

    return {
      close,
    };
  },
};
</script>
